import React from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { Container } from "reactstrap";
import { useTranslation } from "react-i18next";

import natanelLg from "../../../assets/images/logo/natanel-lg.png";
import ProfileMenu from "../../Topbar/ProfileMenu";
import SysAdminSidebar from "./SysAdminSidebar";
import Footer from "../VerticalLayout/Footer";

function SysAdminLayout() {
  const { t } = useTranslation();
  const { authUser } = useSelector((state) => state.Auth);

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        {/* Header */}
        <header id="page-topbar">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box">
                <a href="/sysadmin/dashboard" className="logo logo-light">
                  <span className="logo-lg">
                    <img src={natanelLg} alt="" height="40" />
                  </span>
                </a>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <div className="d-flex align-items-center me-3">
                <span
                  className="badge bg-warning text-dark px-3 py-2"
                  style={{ fontSize: "14px" }}
                >
                  <i className="ri-shield-star-line me-1"></i>
                  {t("SYSADMIN.HEADER_TITLE") || "ניהול מערכת"}
                </span>
              </div>

              <h5 className="mb-0 me-3">{authUser?.firstName || "System Admin"}</h5>

              <ProfileMenu />
            </div>
          </div>
        </header>

        {/* Sidebar */}
        <SysAdminSidebar />

        {/* Main Content */}
        <div className="main-content">
          <div
            className="page-content"
            style={{ minHeight: "calc(100vh - 60px)" }}
          >
            <Container fluid className="px-sm-3 px-2">
              <Outlet />
            </Container>
          </div>

          <Footer />
        </div>
      </div>
    </React.Fragment>
  );
}

export default SysAdminLayout;
